import {type UIChild, UI} from "../../../../stem-core/ui/UIBase.js";
import {CodeEditor} from "../../../../stem-core/ui/CodeEditor.jsx";
import {deepGetAttr, deepSetAttr, toArray} from "../../../../blinkpay/UtilsLib.js";
import {registerStyle} from "../../../../stem-core/ui/style/Theme";
import {styleRule} from "../../../../stem-core/decorators/Style";
import {StyleSheet} from "../../../../stem-core/ui/Style";
import type {BaseEditorState} from "./BaseEditorState";


export class JSONStateInputStyle extends StyleSheet {
    @styleRule
    codeEditor = {
        fontFamily: this.themeProps.FONT_FAMILY_MONOSPACE,
        fontSize: 16,
        width: "100%",
    };
}

interface JSONStateInputOptions {
    advancedMode?: boolean;
    codeEditorHeight?: number;
    state?: BaseEditorState;
    stateKey?: string | string[];
}

@registerStyle(JSONStateInputStyle)
export class JSONStateInput<ExtraOptions = {}> extends UI.Element<JSONStateInputOptions & ExtraOptions> {
    declare jsonEditor?: CodeEditor;
    canOverwrite() {
        return false;
    }

    getDefaultOptions(options?: this["options"]) {
        return {
            ...super.getDefaultOptions(options),
            codeEditorHeight: 250,
        }
    }

    renderFormFields(): UIChild[] {
        return [];
    }

    renderSimplifiedMode() {
        return <div ref="form">
            {this.renderFormFields()}
        </div>;
    }

    renderAdvancedMode() {
        const {state, stateKey} = this.options;
        const value = deepGetAttr(state, toArray(stateKey));
        const strValue = JSON.stringify(value, null, "\t");
        return <CodeEditor ref="jsonEditor"
                           className={this.styleSheet.codeEditor}
                           style={{height: this.options.codeEditorHeight}}
                           aceMode="json"
                           value={strValue}
                           onAceChange={() => this.handleJSONChange(this.jsonEditor.getValue())}/>;
    }

    render() {
        if (this.options.advancedMode ?? this.options.state.advancedMode) {
            return this.renderAdvancedMode();
        }
        return this.renderSimplifiedMode();
    }

    handleJSONChange(stringValue: string) {
        const {state, stateKey} = this.options;
        try {
            const value = JSON.parse(stringValue);
            deepSetAttr(state, toArray(stateKey), value);
            state.error = null;
        } catch {
            state.error = "JSON syntax error";
        }
        state.dispatchChange();
    }
}
